import { Position } from '@/lib/enums';

export default function originPosition(position) {
  const origin = {
    anchor: {
      horizontal: 'center',
      vertical: 'top',
    },
    transform: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  };

  switch (position) {
    case Position.BOTTOM:
      origin.anchor.vertical = 'bottom';
      origin.transform.vertical = 'top';
      break;
    case Position.BOTTOM_LEFT:
      origin.anchor.vertical = 'bottom';
      origin.anchor.horizontal = 'left';
      origin.transform.vertical = 'top';
      origin.transform.horizontal = 'left';
      break;
    case Position.BOTTOM_RIGHT:
      origin.anchor.vertical = 'bottom';
      origin.anchor.horizontal = 'right';
      origin.transform.vertical = 'top';
      origin.transform.horizontal = 'right';
      break;
    case Position.RIGHT:
      origin.anchor.vertical = 'center';
      origin.anchor.horizontal = 'right';
      origin.transform.vertical = 'center';
      origin.transform.horizontal = 'left';
      break;
    case Position.TOP_RIGHT:
      origin.anchor.vertical = 'top';
      origin.anchor.horizontal = 'right';
      origin.transform.vertical = 'top';
      origin.transform.horizontal = 'left';
      break;
    default:
  }

  return origin;
}
